import { useCallback } from "react";
import { flightsSessionStore } from "@flights/web-api-utils-universal";
const key = "offer_alternative_fares_params";
const useAlternativeFaresParams = () => {
    const setAlternativeFaresParams = useCallback((type, data) => {
        const currentData = flightsSessionStore.get(key);
        flightsSessionStore.set(key, { ...currentData, [type]: data });
    }, []);
    const getAlternativeFaresParams = useCallback(() => flightsSessionStore.get(key), []);
    const clearAlternativeFaresParams = useCallback(() => {
        flightsSessionStore.unset(key);
    }, []);
    const setAlternativeFaresSearchedAtParam = useCallback((isMetaUser) => {
        const params = getAlternativeFaresParams();
        if (isMetaUser && !params?.searchedAt) {
            setAlternativeFaresParams("searchedAt", new Date().getTime());
        }
    }, [getAlternativeFaresParams, setAlternativeFaresParams]);
    return {
        setAlternativeFaresParams,
        getAlternativeFaresParams,
        setAlternativeFaresSearchedAtParam,
        clearAlternativeFaresParams
    };
};
export default useAlternativeFaresParams;
